import { useEffect, useRef } from 'react';
import { AppToaster } from './toaster';
import useNewVersionCheck from './useNewVersionCheck';

export default function NewVersionToast() {
  const isNewVersionAvailable = useNewVersionCheck();
  const toastKeyRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!isNewVersionAvailable) return;
    if (toastKeyRef.current) return;

    toastKeyRef.current = AppToaster.show({
      message:
        'A new version of Recap is available. Please refresh to get the latest features and updates.',
      intent: 'primary',
      icon: 'info-sign',
      timeout: 0,
      isCloseButtonShown: true,
      action: {
        text: 'Refresh',
        onClick: () => window.location.reload(),
      },
    });
  }, [isNewVersionAvailable]);

  return null;
}
